import { defineComponent } from "vue";

import ReferralInformationSection from "./ReferralInformationSection/ReferralInformationSection.vue";
import PreadmissionNotes from "./PreadmissionNotes/PreadmissionNotes.vue";

export default defineComponent({
    components: {
        ReferralInformationSection,
        PreadmissionNotes
    }
});
